import { render, staticRenderFns } from "./BannerPage.vue?vue&type=template&id=2332fa46&scoped=true"
import script from "./BannerPage.vue?vue&type=script&lang=js"
export * from "./BannerPage.vue?vue&type=script&lang=js"
import style0 from "./BannerPage.vue?vue&type=style&index=0&id=2332fa46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2332fa46",
  null
  
)

export default component.exports